module.exports = __webpack_public_path__ + "fonts/fontello.12aaa66.ttf";